export type DebugValues = Partial<{
  'app.config.featureFlags.enableStaticSplashJoinRedirect': boolean;
  'app.config.featureFlags.enableJankyABTest': boolean;
  'app.config.featureFlags.enableConfirmationEmailContinueAB': boolean;
  'app.config.featureFlags.enableWideModelPage': boolean;
  'app.config.splashPageType': string;
  'app.jankyABVariant': number;
  'app.server.avr': string;
  'app.server.ipAddress': string;
}>;

export const debugFormTypes: Record<keyof DebugValues, 'checkbox' | 'number' | 'text'> = {
  'app.config.featureFlags.enableStaticSplashJoinRedirect': 'checkbox',
  'app.config.featureFlags.enableJankyABTest': 'checkbox',
  'app.config.featureFlags.enableConfirmationEmailContinueAB': 'checkbox',
  'app.config.featureFlags.enableWideModelPage': 'checkbox',
  'app.config.splashPageType': 'text',
  'app.jankyABVariant': 'number',
  'app.server.avr': 'text',
  'app.server.ipAddress': 'text',
};

export const METART_DEBUG_COOKIE = 'METART_DEBUG_COOKIE';
